import "@fontsource/montserrat";
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";

import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ReactGA from "react-ga";
import { GoogleOAuthProvider } from '@react-oauth/google';

import Landing from "./NewDesign/Landing";


import WeAreYMCRoute from "./NewDesign/WeAreYMCRoute";

import ContactRoute from "./NewDesign/ContactRoute";


const TRACKING_ID = "G-5TSZG25VY0"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

const Router = createBrowserRouter([

 
  
  {
    path: "/",
    element: (
      <>
      <title>Yo Me Controlo</title>

      <Landing />
 
      </>
    ),
  },

  {
    path: "/quienes-somos",
    element: (
      <>
      <title>YMC | Quiénes Somos</title>

      <WeAreYMCRoute />
      </>
    ),
  },
 

  {
    path: "/contacto",
    element: (
      <>
      <title>YMC | Contacto</title>

        <ContactRoute />

      </>
    ),
  },
 
 
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId="373324863794-24umjtie522qdma9b4kro9lg8q7804nj.apps.googleusercontent.com">
<RouterProvider router={Router} />
</GoogleOAuthProvider>
);

const SendAnalytics = () => {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
  });
};

reportWebVitals(SendAnalytics);
